import { Card, Typography } from 'antd';
import { Calendar } from 'lucide-react';

const { Title, Text, Paragraph } = Typography;

export default function MeetingsPage() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '48px 16px' }}>
      <Card
        style={{
          maxWidth: 520,
          width: '100%',
          textAlign: 'center',
          borderStyle: 'dashed',
        }}
      >
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            background: '#fff7e6',
            color: '#d48806',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
          }}
        >
          <Calendar size={28} />
        </div>
        <Title level={3} style={{ marginBottom: 8 }}>
          En construcción
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0, fontSize: 15 }}>
          El módulo de Reuniones está temporalmente desactivado.
          Pronto se integrará con el nuevo calendario de Swomey.
        </Paragraph>
        <Text type="secondary" style={{ display: 'block', marginTop: 16, fontSize: 13 }}>
          La creación y gestión de citas no está disponible por ahora.
        </Text>
      </Card>
    </div>
  );
}
